import "./js/directives";
import "./js/magics";
import "./js/toast";
import "./js/shopify";
import Clipboard from "@ryangjchandler/alpine-clipboard";

import { arrayUnique } from "./js/helpers";

Array.prototype.unique = function (key) {
  return arrayUnique(this, key);
};

import Alpine from "alpinejs";
import anchor from "@alpinejs/anchor";
import collapse from "@alpinejs/collapse";
import persist from "@alpinejs/persist";
import intersect from "@alpinejs/intersect";
import focus from "@alpinejs/focus";

window.Alpine = Alpine;

Alpine.plugin(anchor);
Alpine.plugin(collapse);
Alpine.plugin(persist);
Alpine.plugin(intersect);
Alpine.plugin(focus);
Alpine.plugin(Clipboard);
Alpine.start();

import Swiper from "swiper";
import {
  Pagination,
  Navigation,
  Controller,
  Thumbs,
  EffectFade,
  Autoplay,
} from "swiper/modules";

window.Swiper = Swiper;
Swiper.use([Pagination, Navigation, Controller, Thumbs, EffectFade, Autoplay]);

window.dispatchEvent(new CustomEvent("swiper:init"));
window.dispatchEvent(new CustomEvent("toast:init"));


// Add arrow to the submin button of the TGL Registration Form Builder

window.addEventListener("load", () => {
  Shopify.helpers.waitForElement("#retailerForm").then((element) => {
    const button = element.querySelector('button[type="submit"]');
    const iconContainer = document.createElement("div");

    iconContainer.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 0 320 512" fill="currentColor"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"/></svg>';
    button.appendChild(iconContainer);
  });
});
